// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2C6ND","footer":"styles_footer__3NpXW","passCodeTooltip":"styles_passCodeTooltip__3sc88"};